import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";

import Button from "components/shared/Button/Button";
import Inputs from "components/shared/Inputs/Inputs";
import Swal from "sweetalert2";

const GatewayUpdate = () => {
  let navigate = useNavigate();
  let { id } = useParams();
  const initialState = {
    nome: "",
    codigo: "",
    tipo: "",
    tel: "",
  };

  const [edit, setEdit] = useState(initialState);
  
  const tipoRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
  const codigoRegex = /[^a-z A-Z]/gm;

  const fetchnomesId = () => {
    api.get(`/gateway/${id}`).then((response) => {
      let obj = response.data[0];
      obj = {
        id: obj.OID_GATEWAY,
        nome: obj.DS_NOME,
        codigo: obj.DS_CODIGO,
        tipo: obj.TIPO,
      };
      setEdit(obj);
    });
  };

  const onChangeHandler = (prop) => (event) => {
    setEdit({ ...edit, [prop]: event.target.value });
  };

  const submitHandler = (event) => {
    event.preventDefault();
    const errorStyle = "margin-bottom: 0; font-size: 80%;";
    // if (edit.codigo.match(codigoRegex) || edit.codigo.length < 3) {
    //   Swal.fire({
    //     icon: "warning",
    //     html:
    //       '<p style="margin-bottom: 0;">Digite Um <b>codigo</b> Válido</p>' +
    //       `<p style="${errorStyle}">Apenas Letras e Espaços</p>`,
    //   });
    //   return;
    // }

    // if (!edit.tipo.match(tipoRegex)) {
    //   Swal.fire({
    //     icon: "warning",
    //     text: "Digite um tipo Válido",
    //   });
    //   return;
    // }

    // if (edit.tel.match(/\D/g)) {
    //   Swal.fire({
    //     icon: "warning",
    //     html:
    //       '<p style="margin-bottom: 0;">Digite Um <b>TELEFONE</b> Válido</p>' +
    //       `<p style="${errorStyle}">Apenas NÚMEROS</p>`,
    //   });
    //   return;
    // }
    let body = {
      DS_NOME: edit.nome,
      DS_CODIGO: edit.codigo,
      TIPO: edit.tipo,

    };
    api.put(`/gateway/${id}`, body).then(() => {
      Swal.fire({
        icon: "success",
        title: "gateway atualizado!",
      }).then(() => {
        navigate("/configuracao/gateway");
      });
    }).catch(() => {
      Swal.fire({
        icon: "warning",
        title: "Dados Inválidos!",
      });
    })
  };

  useEffect(() => {
    fetchnomesId();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <label id="component-title">Editar | Gateway</label>
        <div>
          <Button
            icon="bx bx-left-arrow-circle"
            iconPosition="left"
            primaryColor="#f8f7ff"
            hoverColor="#f8f7ff"
            text="Voltar"
            link="/configuracao/gateway"
            styles={{
              marginLeft: "1.5rem",
              background: "#f8f7ff",
              color: "blue",
            }}
          />
        </div>
        <form className="component-form container" style={{ margin: "0px" }}>
          <div className="container">
            <div className="row">
              <div className="col-6">
                <Inputs
                  id="fab-edit"
                  label="Nome"
                  value={edit.nome}
                  onChange={onChangeHandler("nome")}
                  styles={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Inputs
                  id="fab-register"
                  label="codigo"
                  value={edit.codigo}
                  onChange={onChangeHandler("codigo")}
                  styles={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Inputs
                  id="fab-register"
                  label="Tipo"
                  value={edit.tipo}
                  onChange={onChangeHandler("tipo")}
                  styles={{ width: "100%" }}
                />
              </div>
            </div>
         
            <div className="row">
              <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
                <Button
                  icon="ti-agenda"
                  text="Atualizar"
                  action={submitHandler}
                  primaryColor="#5d4ec0"
                  hoverColor="#4eadc0"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
};

export default GatewayUpdate;
